import RequiredFieldInfo from './RequiredFieldInfo';

export default RequiredFieldInfo;
